
import { Autocomplete, Box, Popper, TextField } from "@mui/material";
import {useState} from "react";

interface OptionType {
  label: string;
  value: number;
}

interface DayPickerProps {
    width?: number;
    height?: number;
    day?: OptionType;
    dayOptions?: any;
    dayDisplayKey?: string;
    isDisabled?: boolean;
    daysInMonth?: number;
    disableClear?: boolean;
    handleDayPicker?: (value: number) => void;
}

const DayPicker = (props: DayPickerProps) => {
    const {width, height, dayOptions, day, dayDisplayKey, daysInMonth, isDisabled, disableClear, handleDayPicker} = props;
    const GridPopper = (props: any) => {
        return <Popper {...props} style={{ width: 250 }} placement="bottom-start" />;
    };

    return(
        <div>
            <Autocomplete
                options={dayOptions}
                getOptionLabel={(option:any) => option[`${dayDisplayKey}`]}
                value={day}
                PopperComponent={GridPopper}
                disableClearable={disableClear}
                isOptionEqualToValue={(option, val) =>
                    option?.[`${dayDisplayKey}`] == day?.[`${dayDisplayKey}`]
                }
                onChange={(event, value) => {
                    if (value) {
                        handleDayPicker?.(value.value);
                    }
                }}
                disabled={isDisabled}
                renderOption={(props, option) => (
                    <li {...props}
                        style={{
                            display: "inline-block", 
                            width: "auto",
                            padding: 0,
                            margin: 2,
                        }}>
                    <Box
                        sx={{
                        width: option.value == daysInMonth ? 100 : 30,
                        height: 30,
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        textAlign: "center",
                        lineHeight: "30px",
                        cursor: "pointer",
                        }}
                    >
                        {option[`${dayDisplayKey}`]}
                    </Box>
                    </li>
                )}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    size="small"
                    sx={{ "& .MuiInputBase-root": { height: height } }}
                    />
                )}
                sx={{ width: width, height: height,
                    "& .MuiAutocomplete-listbox": {
                        display: "grid",
                        gridTemplateColumns: "repeat(7, auto)",
                        gap: "4px",
                        padding: "4px 8px",},
                    }}
            />
        </div>
    )
}

export default DayPicker;